module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('headersection', {
    attrs: {
      "headdata": _vm.homeheader
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('card', {
    attrs: {
      "cardInfo": _vm.cardInfo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('window', {
    attrs: {
      "object": _vm.object
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-754be99e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/home.vue
// module id = 276
// module chunks = 2